import type Keycloak from 'keycloak-js';
import { getOrgAlias } from '../utils/tokenUtils';

/**
 * Keycloak's account console for the signed-in user, in the user's
 * organization (`org=<alias>`), keeping keycloak-js's link back to the cockpit.
 */
export function accountUrl(keycloak: Keycloak): string {
  const url = new URL(keycloak.createAccountUrl());
  const alias = keycloak.token ? getOrgAlias(keycloak.token) : null;
  if (alias) url.searchParams.set('org', alias);
  return url.toString();
}

/** Opens the account console ("My account" in the menu). */
export function openAccount(keycloak: Keycloak | undefined): void {
  if (keycloak) window.location.assign(accountUrl(keycloak));
}
